// Phase 7B Lot 3 — alias for Header so new public pages can import SiteNav.
// Header already handles its own dark/light state based on scroll position.
// The optional `variant` prop is accepted but currently ignored (Header is
// stateful and adapts on its own).
import Header from "@/components/Header";

export default function SiteNav(_props) {
    return <Header />;
}
